import React from 'react'
import StructureInstallation from './Components/StructureInstallation'

const StructureInstallationPage = () => {
  return (
    <div>
      <StructureInstallation />
    </div>
  )
}

export default StructureInstallationPage